// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'document-upload-solid';

export const Component = () => (
  <path d='M22.595 7.855h-6.37c-.431 0-.766-.144-1.054-.432a1.408 1.408 0 0 1-.431-1.053V0H3.485c-.431 0-.766.144-1.054.431A1.408 1.408 0 0 0 2 1.485v21.552c0 .431.144.766.431 1.054.288.287.623.43 1.054.43H21.11c.432 0 .767-.143 1.054-.43.288-.288.432-.623.432-1.054V7.855Zm-6.85 5.364a.54.54 0 0 1-.143.383.546.546 0 0 1-.383.143.434.434 0 0 1-.335-.143l-2.107-2.107v7.614c0 .336-.144.527-.48.527-.335 0-.478-.191-.478-.527v-7.614l-2.107 2.107c-.192.096-.288.143-.335.143-.336 0-.527-.191-.527-.526 0-.048.048-.144.144-.335l2.97-2.921a.434.434 0 0 1 .334-.144c.144 0 .24.047.336.143l2.97 2.922a.434.434 0 0 1 .143.335h-.002Zm0-6.85L15.698.288l6.465 6.466.096.096h-6.034c-.335 0-.479-.144-.479-.479Z' />
);

export const viewBox = '0 0 25 25';
